<template>
  <compare-power-card
      v-if="deposit_payment_error_codes.includes(order_status)">
    <compare-power-card-header>
      <div class="flex items-center">
        <q-icon name="o_credit_card" class="q-mr-md"></q-icon>
        <div>Refundable Deposit Payment</div>
      </div>
    </compare-power-card-header>
    <slot></slot>
  </compare-power-card>
</template>

<script>
import Orders from "src/composables/Orders";
import ComparePowerCard from "components/ComparePowerCard";
import ComparePowerCardHeader from "components/ComparePowerCardHeader";

export default {
  name: "DepositPaymentBase",
  components: { ComparePowerCardHeader, ComparePowerCard },
  setup() {
    const { order_status, deposit_payment_error_codes } = Orders();
    return { order_status, deposit_payment_error_codes }
  }
}
</script>

<style scoped>

</style>
